import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../environments/environment";

export interface ActivationEmailApiError {
  translationKey?: string;
  rawMessage?: string;
}

@Injectable({ providedIn: "root" })
export class ActivationEmailService {
  constructor(private http: HttpClient) {}

  async resendActivationEmail(email: string): Promise<ActivationEmailApiError | null> {
    if (!environment.resendActivationEmailUrl) {
      return { translationKey: "updatePassword.resendUnavailable" };
    }

    const headers: Record<string, string> = { email };
    if (environment.resendActivationEmailSubscriptionKey) {
      headers["Ocp-Apim-Subscription-Key"] = environment.resendActivationEmailSubscriptionKey;
    }

    try {
      await firstValueFrom(
        this.http.get(environment.resendActivationEmailUrl, { headers })
      );
      return null;
    } catch (err) {
      if (err instanceof HttpErrorResponse && typeof err.error?.message === "string") {
        return { rawMessage: err.error.message };
      }
      return { translationKey: "updatePassword.resendError" };
    }
  }
}
